export default {
  'mainTerms': {
    'rus': 'рус',
    'eng': 'eng'
  },
  'pages': {
    'select': {
      'title': 'Кабинет сотрудника',
      'theyAreWorking': 'Работающие сотрудники',
      'currentTime': 'Текущее время',
      'searchInput': 'Введите имя или фамилию',
      'findButton': 'Найти',
      'workTime': 'Время работы',
      'from': 'с',
      'till': 'до',
      'department': 'отдел',
      'company': 'компания',
      'ticks': 'Отметки',
      'tabelCode': 'Табельный номер',
      'position': 'Должность',
      'selectEmployee': 'Выберите сотрудника',
      'coming': 'Приход',
      'leaving': 'Уход',
      'noTabelcode': 'Нет табельного номера',
      'noPosition': 'Нет должности'
    },
    'fix': {
      'title': 'Отметка сотрудника',
      'worker': 'Сотрудник',
      'shortInstruction': 'Расположитесь так, чтобы лицо находилось по центру круга',
      'shootButtonTitle': 'Сделать снимок',
      'reshootButtonTitle': 'Переснять',
      'sendButtonTitle': 'Отправить',
      'coming': 'Приход',
      'leaving': 'Уход',
      noFirstPicsError: 'Ошибка сохранения изображения с камеры. Попробуйте ещё раз.'
    },
    'results': {
      'title': 'Результат отметки',
      'comingOnSchedule': 'Вы сегодня пришли вовремя!',
      'nonMarked': 'Отметка вне плана!',
      'comingLate': 'К сожалению, Вы опоздали!',
      'leavingOnSchedule': 'Вы ушли вовремя. Спасибо за работу!',
      'leavingDumped': 'Вы ушли невовремя',
      'tickSuccess': 'Отметка прошла успешно,',
      'tickFailure': 'Извините, Ваше лицо не распознано',
      'tickOffline': 'Ваше фото будет обработано позже, поскольку в данный момент интернет-соединение отсутствует',
      'understood': 'Всё понятно',
      'tryAgain': 'Попробовать ещё раз',
      'todayPlan': 'План работы на сегодня',
      'planElementWaiting': 'Ожидает выполнения'
    }
  },
  'mainLayout': {
    'shopTitle': 'магазин',
    'errorModalTitle': 'Ошибка!'
  },
  'api': {
    502: 'Сервис временно недоступен. Пожалуйста, попробуйте позже.'
  }
}
